<template>
  <v-list-item v-if="!isEditing" ripple class="it-hv">
    <v-list-item-avatar class="my-0">
      <v-icon small>fal fa-venus-mars</v-icon>
    </v-list-item-avatar>
    <v-list-item-content>
      <v-list-item-subtitle class="caption" v-if="!isPrintEmpty">性別</v-list-item-subtitle>
      <v-list-item-title>{{ printSex }}</v-list-item-title>
    </v-list-item-content>
    <v-list-item-action>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on" color="secondary" :loading="isThisLoading" @click="edit">
            <v-icon small>fal fa-pencil</v-icon>
          </v-btn>
        </template>
        <span>編集する</span>
      </v-tooltip>
    </v-list-item-action>
  </v-list-item>
  <v-container v-else>
    <v-subheader>性別</v-subheader>
    <v-row dense class="pb-4">
      <v-col cols="12" class="px-3">
        <v-radio-group required row
          v-model="form.sex.content"
          :rules="rules.sex">
          <v-radio v-for="(item, key) in getSexItems" :key="key"
            color="blue darken-2"
            :label="item"
            :value="key"
          />
        </v-radio-group>
      </v-col>
    </v-row>
    <v-divider></v-divider>
  </v-container>
</template>

<script>
export default {
  name: 'clientAboutBasicSex',
  props: [
    'status',
    'data'
  ],
  data () {
    return {
      form: {
        sex: {
          id: '',
          content: ''
        }
      },
      rules: {
        sex: [
          v => !!v || '必須項目です'
        ]
      }
    }
  },
  methods: {
    prepare: function () {
      if (
        this.$props.data &&
        this.$props.data.sex
      ) {
        this.$set(this.form, 'sex', {
          id: '' + (this.$props.data.sex.id ? this.$props.data.sex.id : 'new_sex'),
          content: this.$props.data.sex.content ? this.$props.data.sex.content : ''
        })
      } else {
        this.$set(this.form, 'sex', {
          id: 'new_sex',
          content: ''
        })
      }
    },
    edit: function () {
      this.prepare()
      this.$emit('emit', {
        action: 'edit',
        data: {
          type: 'sex'
        }
      })
    },
    getForm: function () {
      return this.form
    }
  },
  computed: {
    isEditing () {
      return !!(
        this.$props.status &&
        this.$props.status.editing &&
        ['sex', 'all'].includes(this.$props.status.editing)
      )
    },
    isThisEditing () {
      return !!(
        this.$props.status &&
        this.$props.status.editing &&
        this.$props.status.editing === 'sex'
      )
    },
    isLoading () {
      return !!(
        this.$props.status &&
        this.$props.status.loading &&
        ['sex', 'all'].includes(this.$props.status.loading)
      )
    },
    isThisLoading () {
      return !!(
        this.$props.status &&
        this.$props.status.loading &&
        this.$props.status.loading === 'sex'
      )
    },
    isPrintEmpty () {
      return !(
        this.$props.data &&
        this.$props.data.sex &&
        this.$props.data.sex.content &&
        this.$mango.sex[this.$props.data.sex.content]
      )
    },
    getSexItems () {
      return this.$mango.sex
    },
    printSex () {
      return (
        this.$props.data &&
        this.$props.data.sex &&
        this.$props.data.sex.content &&
        this.$mango.sex[this.$props.data.sex.content]
      ) ? this.$mango.sex[this.$props.data.sex.content] : '性別'
    }
  }
}
</script>
